import React, { useEffect, useState } from 'react';
import { Star } from "@kursk/components/ui/icons";
import styles from './Rating.module.scss';
import stylesExportedVars from 'styles/export_vars.module.scss';

interface IProps {
  rating: number;
  setRating?: React.Dispatch<React.SetStateAction<number>>;
  count?: number;
  withoutNumber?: boolean;
  starSelect?: boolean;
  selectedColorStar?: string;
  noSelectedColorStar?: string;
  starSize?: number;
}

export interface IStars {
  styleId: null | number;
  startOffset: null | string;
  endOffset: null | string;
  selectedColorStar?: string;
  noSelectedColorStar?: string;
  size?: number;
}

export const Rating = (({
  rating,
  setRating,
  withoutNumber,
  count = 10,
  starSelect,
  selectedColorStar = stylesExportedVars.ratingstarfilled,
  noSelectedColorStar = stylesExportedVars.ratingstarempty,
  starSize = 12,
}: IProps) => {
  const [stars, setStars] = useState<IStars[]>();

  /* В данном методе мы создаем массив звезд с уже заранее заданными параметрами, которые формируются
  * на основе присвоенного рейтинга.
  * Мы заполняем три поля:
  * 1.  styleId - используется для тега <path> для его параметра fill. Таким образом конкретная звезда
  * знает какой стиль ей нужно использовать
  * 2. startOffset-используется для определения места в звезде в процентном выражении, где должен закончится желтый цвет
  * 3. endOffset-используется для определения места в звезде в процентном выражении, где должен начаться зеленый цвет +
  * Далее нам нужно определить, какие звезды нам нужно закрашивать полностью, какие нет, какие частично
  * и в каком месте происходит переход с золотого цвета на простой.
  * Для этого мы сравниваем рейтинг с индексом звезды в массиве, увеличенную на 1. Если позиция в массиве меньше
  * рейтинга, то звезда закрашивается,
  * если позиция в массиве больше рейтинга то не закрашивается, если разница между позицией в массиве и рейтингом
  * меньше 1, но больше нуля, то в таком случае определяем
  * пропорцию, в которой будем окрашивать звезду */
  const generateStarArray = () => {
    const stars: IStars[] = [];
    for (let i = 1; i <= count; i++) {
      const star = {
        styleId: null,
        startOffset: null,
        endOffset: null,
      }
      let startOffset: string, endOffset: string;
      if (rating >= i) {
        startOffset = '100%';
        endOffset = '100%';
      }
      if (rating < i && ((i - rating) < 1)) {
        startOffset = ((1 - (i - rating)) * 100) + '%';
        endOffset = ((1 - (i - rating)) * 100) + '%';
      }
      if (rating < i && ((i - rating) >= 1)) {
        startOffset = '1%';
        endOffset = '1%';
      }
      star.styleId = Math.random() + Math.random();
      star.startOffset = startOffset;
      star.endOffset = endOffset;
      stars.push(star);
    }
    setStars(stars);
  };

  useEffect(generateStarArray, [rating]);

  if (!rating && rating !== 0) {
    return <></>;
  }
  return (
    <div className={styles.container}>
      {!withoutNumber && (<div>{Number.isInteger(rating) ? `${rating},0` : rating}</div>)}
      <div className={styles.starsContainer}>
        {
          stars && stars.map((star, index) => (
            <>
              {starSelect ? (
                <div
                  key={star.styleId + index}
                  className={styles.starRating}
                  onClick={() => setRating(++index)}
                >
                  <Star
                    startOffset={star.startOffset}
                    endOffset={star.endOffset}
                    styleId={star.styleId}
                    noSelectedColorStar={noSelectedColorStar}
                    selectedColorStar={selectedColorStar}
                    size={starSize}
                  />
                </div>
              ) : (
                <Star
                  key={star.styleId + index}
                  startOffset={star.startOffset}
                  endOffset={star.endOffset}
                  styleId={star.styleId}
                  noSelectedColorStar={noSelectedColorStar}
                  selectedColorStar={selectedColorStar}
                  size={starSize}
                />
              )}
            </>
          ))
        }
      </div>
    </div>)
})
